module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMA9kI3R/k7qRLP6Qvh3O7lVh0XELyl1bCdkGhMJseMiGxfCVHY3hAAAACSSURBVCjPzcxJDoMwDEBRkzRMJSEDM3T0/e9YJ3SBCMtW4i1sWV8y/Jhpk9hgqPSoL3sTPqioAmIio1EelOuJC4RSSxaZRUtF4pGBiur417N68RUL326KpR7nU615Gsx4p2KbJBCYlALFemQGvNxzIy45Q+3CBVtV40cGO25pVWqt1Tgatw3vphZVJ6UsaPfwBx8g/At2po7wLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/product.png?20181011
// module id = PEW0
// module chunks = 1